import { useEffect } from "react";
import useFeatures from "./hooks/useFeatures";
import useAnalytics from "./hooks/useAnalytics";
import { postPageLoad } from "./analytics/postPageLoad/postPageLoad";
import { useRuntimeConstants } from "./context/runtimeConstants/RuntimeConstantsContext";
import {
  MixAndMatchPage,
  SingleProductPage,
  UnavailableProductPage,
} from "./pages";
import { isProductUnavailable } from "../utils/productUtils";
import useSetNotificationsOnReturnFromLogin from "./hooks/useLoginReturn";

export default function CriticalApp() {
  const { isMixAndMatch, storeCode, product } = useRuntimeConstants();

  useSetNotificationsOnReturnFromLogin();
  useFeatures();
  useAnalytics();

  useEffect(() => {
    postPageLoad();
  }, []);

  if (isMixAndMatch) {
    return <MixAndMatchPage />;
  }

  if (isProductUnavailable(product, storeCode)) {
    return <UnavailableProductPage />;
  }

  return <SingleProductPage />;
}
